<template>
  <div class="page-item">
    <section class="top">
      <h3>{{ item.title }}</h3>
      <p>
        来源：{{ item.source }}<span>{{ item.data | dataFilter }}</span>
      </p>
    </section>
    <section class="center">
      <van-image :src="item.img" v-if="type == 'img'">
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
      </van-image>
      <div class="video-box" v-if="type == 'video'">
        <video ref="video" preload="auto" :poster="item.posterUrl" controls>
          <source :src="item.src" type="video/mp4" />
          <source :src="item.src" type="video/ogg" />
          您的浏览器不支持 video 标签。
        </video>
        <!-- <div class="cover-play" @click="videoPlay" v-show="videoCover"><van-icon name="play-circle-o" /></div> -->
      </div>
    </section>
    <section class="bottom" :class="type == 'video' ? 'videoStyle' : ''">
      <h5 v-if="type == 'img'">
        <span>{{ nowIndex }}</span> / {{ dataleng }}
      </h5>
      <h6>{{ item.content }}</h6>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nowIndex: 1
      // videoCover:true
    }
  },
  props: {
    item: {},
    index: {
      type: [Number, String],
      default: 1
    },
    dataleng: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: 'img'
    }
  },
  watch: {
    index(newVal) {
      this.nowIndex = newVal
    }
  },
  methods: {
    // videoPlay(){
    //      this.$refs.video.play()
    // }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
.page-item {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #000;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  section {
    overflow: hidden;
  }
  .top {
    padding: 0.3rem;
    height: 2rem;
    h3 {
      font-size: 0.36rem;
      line-height: 0.54rem;
      @include ellipsisMultiline($number: 2);
    }
    p {
      font-size: 0.24rem;
      color: #999;
      padding-top: 0.1rem;
      span {
        float: right;
      }
    }
  }
  .center {
    flex: 1;
    -webkit-flex: 1;
    overflow: hidden;
    position: relative;
    .van-image {
      width: 100%;
      height: 100%;
      overflow: hidden;
      /deep/img {
        display: block;
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
    }
    .video-box {
      width: 100%;
      height: 4rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      transform: -webkit-translate(-50%, -50%);
      video {
        width: 100%;
        height: 100%;
      }
      // .cover-play{
      //   position: absolute;
      //   top: 0;
      //   left: 0;
      //   width:100%;
      //   height:100%;
      //   background: rgba(0,0,0,.4);
      //   text-align: center;
      //   line-height: 4rem;
      //   font-size: .8rem;
      //   font-weight: 400;
      //   color: #fff;
      // }
    }
  }
  .bottom {
    padding: 0 0.3rem 0.3rem;
    height: 2rem;
    h5 {
      padding-top: 0.1rem;
      line-height: 0.5rem;
      font-size: 0.26rem;
      span {
        font-size: 0.32rem;
      }
    }
    h6 {
      font-size: 0.28rem;
      line-height: 0.45rem;
      @include ellipsisMultiline($number: 2);
    }
    &.videoStyle {
      h5 {
        display: none;
      }
      h6 {
        @include ellipsisMultiline($number: 3);
      }
    }
  }
}
</style>
